import "./sofr_frontend.js";
import "./schulportal.css";

// If you are using JavaScript/ECMAScript modules:
import { Application } from "@hotwired/stimulus";
import ApplicationController from "./controllers/application_controller";

import DropdownController from "./controllers/dropdown_controller.js";

import YformController from "./controllers/yform_controller.js";
import SchulprofilController from "./controllers/schulprofil_controller";
import JourdienstController from "./controllers/jourdienst_controller";
import AufgabentraegerController from "./controllers/aufgabentraeger_controller";
import ErwSLController from "./controllers/erwsl_controller";
import LoginController from "./controllers/login_controller";
// import BSFachbetreuungController from "./controllers/bs_fachbetreuung_controller";
import BSFunktionenplanController from "./controllers/bs_funktionenplan_controller";
import BSVasController from "./controllers/bs_vas_controller";
import SortableController from "./controllers/sortable_controller.js";
import TaglistController from "./controllers/taglist_controller.js";
import TooltipController from "./controllers/tooltip_controller.js";
import XlsxController from "./controllers/xlsx_controller.js";

Stimulus.register("dropdown", DropdownController);
Stimulus.register("yform", YformController);
Stimulus.register("sortable", SortableController);
Stimulus.register("taglist", TaglistController);
Stimulus.register("schulprofil", SchulprofilController);
Stimulus.register("jourdienst", JourdienstController);
Stimulus.register("aufgabentraeger", AufgabentraegerController);
Stimulus.register("erwsl", ErwSLController);
// Stimulus.register("bsfachbetreuung", BSFachbetreuungController);
Stimulus.register("bsfunktionenplan", BSFunktionenplanController);
Stimulus.register("bsvas", BSVasController);
Stimulus.register("login", LoginController);
Stimulus.register("tooltip", TooltipController);
Stimulus.register("xlsx", XlsxController);

// Stimulus.register("bsfachbetreuung", BSFachbetreuungController);
